// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateModalBody from './modal-body';
import LaborRateModalHeader from './modal-header';
import TcsmApproveDenyModal from '../../../wip/state/tcsm-approve-deny-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const LaborRateModal = props =>
    <section className='labor-rate-modal'>
        <WarrantyMediumModal isOpen={props.laborRateModal.isVisible}>
            <LaborRateModalHeader
                actionToTake={props.laborRateModal.actionToTake}
                onClose={props.onClose}
                onConfirmation={props.onConfirmation}
            />
            <LaborRateModalBody
                laborRate={props.laborRate}
                onCommentsToDealerChange={props.onCommentsToDealerChange}
                onInternalDeereCommentsChange={props.onInternalDeereCommentsChange}
            />
        </WarrantyMediumModal>
    </section>;

LaborRateModal.displayName = 'LaborRateModal';
LaborRateModal.propTypes = {
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    laborRateModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    onClose: PropTypes.func.isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default LaborRateModal;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/modal/index.js